import { STACK } from '../config';

export const createPendoData = ({
  clientId,
  personnelId,
}: {
  clientId: string;
  personnelId: string;
}) => {
  const visitorData = {
    id: `${clientId}/${personnelId}`,
    name: personnelId,
    timezone: 'Indian Standard Time',
    personnelLanguage: 'en',
    user_role: 'user',
    screen_width: window.screen.width,
    screen_height: window.screen.height,
  };

  const accountData = {
    id: `${clientId}/${personnelId}`,
    name: personnelId,
    stage: STACK,
  };

  return { visitorData, accountData };
};
